import { useId } from "react";
import { useLocale } from "../i18n";
import { FieldRequirement } from "../components/FieldRequirement";
import "../styles/invitation-email.css";

export function InvitationEmailInput({ value, disabled, onChange }: { value: string; disabled: boolean; onChange: (value: string) => void }) {
  const { w } = useLocale(); const id = useId();
  return <div className="invitation-email-input"><label htmlFor={id}>{w("إيميل المستلم", "Recipient email")} <FieldRequirement required /></label>
    <input id={id} type="email" dir="ltr" autoComplete="off" maxLength={512} required disabled={disabled} value={value} onChange={event => onChange(event.target.value)} aria-describedby={`${id}-hint`} />
    <p id={`${id}-hint`}>{w("تحتاج الدعوة إلى إثبات ملكية هذا البريد وقبول المستلم؛ لا تمنح عضوية أو دوراً بمجرد حفظها.", "The recipient must verify ownership of this email and accept. Saving an invitation alone grants no membership or role.")}</p>
  </div>;
}
